import React from 'react';
import ConfigureDeploymentModal from '@/features/deployments/components/ConfigureDeploymentModal';
import DuplicateEcrPushConfirmModal from '@/features/deployments/components/DuplicateEcrPushConfirmModal';
import DuplicateDockerHubPushConfirmModal from '@/features/deployments/components/DuplicateDockerHubPushConfirmModal';
import DownloadQuoteModals from '@/features/billing/components/DownloadQuoteModals';

/**
 * Modal chain owned by ``useConfigureDeploymentFlow``: the single Download
 * Model modal (format cards + configuration; the download price sits in its
 * footer) → not-enough-credits → duplicate-registry confirm.
 *
 * Shared by the Models page, Evaluation's Model Details drawer, and the
 * task-page kebab Download action so those surfaces stay in lockstep.
 */
export default function ConfigureDeploymentFlowModals({ configureFlow, allUsecases }) {
  const isDockerHubPush =
    configureFlow.duplicatePushConfirm?.artifactType === 'dockerhub';

  return (
    <>
      <ConfigureDeploymentModal
        open={configureFlow.configureModal.open}
        mode={configureFlow.configureModal.mode}
        formatMode={configureFlow.configureModal.formatMode}
        training={configureFlow.configureModal.training}
        availableTrainings={configureFlow.eligibleTrainings}
        allUsecases={allUsecases}
        instancesCapErrorByTaskKey={configureFlow.configureModal.instancesCapErrorByTaskKey}
        focusedTaskKey={configureFlow.configureModal.focusedTaskKey}
        onClearInstancesCapErrorForTask={configureFlow.handleClearInstancesCapErrorForTask}
        onFocusedTaskKeyChange={configureFlow.handleFocusedTaskKeyChange}
        onCancel={configureFlow.handleConfigureCancel}
        onConfirm={configureFlow.handleConfigureConfirm}
      />
      <DuplicateEcrPushConfirmModal
        open={!!configureFlow.duplicatePushConfirm && !isDockerHubPush}
        previousPush={configureFlow.duplicatePushConfirm?.previousPush}
        onCancel={configureFlow.handleDuplicatePushCancel}
        onConfirm={configureFlow.handleDuplicatePushConfirm}
        confirmLoading={configureFlow.duplicatePushSubmitting}
      />
      <DuplicateDockerHubPushConfirmModal
        open={!!configureFlow.duplicatePushConfirm && isDockerHubPush}
        previousPush={configureFlow.duplicatePushConfirm?.previousPush}
        onCancel={configureFlow.handleDuplicatePushCancel}
        onConfirm={configureFlow.handleDuplicatePushConfirm}
        confirmLoading={configureFlow.duplicatePushSubmitting}
      />
      <DownloadQuoteModals gate={configureFlow.downloadGate} />
    </>
  );
}
